import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";

/**
 * Props for `ChooseAProviderIntro`.
 */
export type ChooseAProviderIntroProps =
  SliceComponentProps<Content.ChooseAProviderIntroSlice>;

/**
 * Component for "ChooseAProviderIntro" Slices.
 */
const ChooseAProviderIntro: FC<ChooseAProviderIntroProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation} 
      className="font-fellix text-jade px-4 md:px-8 lg:px-12 py-24 " 
    >
      <div className='max-w-[880px] mx-auto text-center'>
        <article className="prose prose-h2:!text-[28px] prose-h2:!leading-[32px] max-w-none">
          <PrismicRichText field={slice.primary.headline}/>
        </article>
        <article className="my-12 prose prose-p:mb-4 prose-p:leading-[24px] prose-p:text-[18px] max-w-none choose-intro text-center">
          <PrismicRichText field={slice.primary.paragraph}/>
        </article>
        <article className="mb-12 block">
          <PrismicRichText field={slice.primary.legals}/>
        </article>
    </div>
    </section>
  );
};

export default ChooseAProviderIntro;
